/**
 * URL操作のHelperFunctions
 */
class UrlHelper {
  constructor() {}
  _queryParams() {
    return new URLSearchParams(window.location.search)
  }
  changeQueryParams(key, value) {
    const queryParams = this._queryParams()
    queryParams.set(key, value)
    window.history.replaceState(null, null, '?' + queryParams.toString())
  }
  escapeQueryParams(value) {
    return value.replace(/‐/g, '-').replace(/‑/g, '-').replace(/–/g, '―').replace(/—/g, '―').replace(/−/g, '―')
  }
}

export const $urlHelper = new UrlHelper()
